import PropTypes from 'prop-types'
import styled from 'styled-components/macro'

import { IconArrowsRoundTrip, IconContract } from '@loadsmart/icons'
import { getToken } from '@loadsmart/loadsmart-ui/dist/theming'

const regularIconSizes = `
    width: 22px;
    height: 22px;
`

const BadgesList = styled.div`
  display: flex;
  flex-flow: row nowrap;
  align-items: center;

  color: ${getToken('color-neutral-darker')};

  > * {
    margin-right: 5px;
  }
`

const ContractedBadge = styled(IconContract)`
  ${regularIconSizes};
`

const IconLoadCandidateBadge = styled(IconArrowsRoundTrip)`
  ${regularIconSizes};
  color: ${getToken('color-warning')};
`

const OfferTypeTextBadge = styled.div`
  margin-right: 8px;
  padding: 3px;

  color: ${getToken('color-neutral-lightest')};
  font-weight: 700;
  font-size: 13px;
  font-size: 9px;

  background-color: ${getToken('color-neutral-darker')};
  border-radius: 2px;
`

function OfferTypeBadges(props) {
  const isAnyValid = Object.values(props).includes(true)

  if (!isAnyValid) {
    return null
  }

  return (
    <BadgesList>
      {props.isVip && <OfferTypeTextBadge title="VIP Badge">VIP</OfferTypeTextBadge>}
      {props.isContracted && <ContractedBadge title="Contracted Badge" />}
      {props.isLoadCandidate && <IconLoadCandidateBadge title="ShipperDirect Load" />}
    </BadgesList>
  )
}

OfferTypeBadges.propTypes = {
  isVip: PropTypes.bool,
  isContracted: PropTypes.bool,
  isLoadCandidate: PropTypes.bool,
}

OfferTypeBadges.defaultProps = {
  isVip: false,
  isContracted: false,
  isLoadCandidate: false,
}

export { OfferTypeBadges }
